const initialState = {
  paises: [],
  isRequestingPaises: false,
  selectedPais: null
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'REQUEST_PAISES':
      return {
        ...state,
        isRequestingPaises: true
      }
    case 'RECEIVE_PAISES':
      return {
        ...state,
        isRequestingPaises: false,
        paises: action.paises
      }
    case 'SET_PAIS':
      return {
        ...state,
        selectedPais: action.pais
      }
    default:
      return state
  }
}
